import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { RequestsService } from '../../_shared/services/requests.service'
import * as moment from 'moment'

@Component({
  selector: 'app-crop-list',
  templateUrl: './crops-table.component.html',
  styleUrls: ['./crops-table.component.scss'],
})
export class CropsTableComponent implements OnInit {
  @Output() successEvent = new EventEmitter()
  @Output() successMessage = new EventEmitter()
  constructor(private RequestService: RequestsService) {}
  page = 1
  count = 10
  loading = false
  inputs = []
  cropDetails = []
  openSuccessModal = false
  marketInfo = []
  selectedCrop: string
  selectedCropRecord: object
  message = null
  errors = null
  InputId = null
  inputDelete: object
  openAddModal = false
  openEditModal = false
  openDeleteModal = false
  success = false
  selectedCsv: File = null
  selectedCrops: any
  selectCrop = []

  handleFileSelect($event) {
    this.selectedCsv = $event.target.files[0]
  }
  ngOnInit() {
    this.reloadInput()
  }
  getAllInput(): void {
    this.loading = true
    const url = 'dashboard/market-info'
    this.RequestService.dash_get(url, null).subscribe((response) => {
      const latestDateInMs = Math.max(
        ...this.dateToMilliseconds(response.dates)
      )
      const latestDateString = moment(
        new Date(latestDateInMs).toString()
      ).format('YYYY-MM-DD')
      const avgSet = response.avg_results
      this.marketInfo = response.mkt_info
      this.loading = false
      let crops = []
      avgSet[latestDateString].forEach((item) => {
        // item['avg_retail'] = Number(item['avg_retail']).toLocaleString();
        // item['avg_wholesale'] = Number(item['avg_wholesale']).toLocaleString();
        this.inputs.push(item)
        crops.push({ label: item.crop, value: item.crop })
        console.log(item)
      })

      this.selectCrop = crops.filter(
        (value, index, array) =>
          !array.filter(
            (v, i) => JSON.stringify(value) == JSON.stringify(v) && i < index
          ).length
      )
      // this.inputs = response.avg_results[latestDateString];
      // console.log('result: ' + JSON.stringify(this.inputs));
      // console.log('latest-date: ' + JSON.stringify(latestDateString));
    })
  }
  dateToMilliseconds(dateArray) {
    const dateMilliseconds = []
    dateArray.forEach((element) => {
      dateMilliseconds.push(Date.parse(element))
    })
    return dateMilliseconds
  }
  reloadInput() {
    this.getAllInput()
  }
  viewDetails(crop: string): void {
    // console.log('crop-selected: ' + crop);
    this.selectedCrop = crop
    this.marketInfo.forEach((item) => {
      if (item['commodity'] === crop) {
        this.cropDetails.push(item)
      }
    })
  }
  viewCropInfo(data: object): void {
    this.selectedCropRecord = data
    // console.log('selected-record: ' + JSON.stringify(this.selectedCropRecord));
    this.openSuccessModal = false
  }
  updateInput(updateInputForm, id) {
    this.loading = true
    const form = updateInputForm
    const URL = `dashboard/cropRecord/${id}`
    const formData = new FormData()
    const date = moment(new Date().toString()).format('YYYY-MM-DD')

    this.selectedCropRecord['time'] = date
    this.selectedCropRecord['market'] = form.market
    this.selectedCropRecord['retailprice'] = Number(form.retailprice)
    this.selectedCropRecord['wholesaleprice'] = Number(form.wholesaleprice)

    // formData.append('_method', 'PUT');
    this.RequestService.dash_put(URL, this.selectedCropRecord).subscribe(
      (response) => {
        this.message = response.message
        this.openSuccessModal = true
        window.location.reload()
      },
      (error) => this.catchError(error)
    )
  }
  // handleFileSelect(evt) {
  //   const files = evt.target.files; // FileList object
  //   const file = files[0];
  //   const reader = new FileReader();
  //   reader.readAsText(file);
  //   reader.onload = (event: any) => {
  //     const csv = event.target.result; // Content of CSV file
  //     console.log('csv-file: ', csv.length);
  //   };
  // }
  uploadMarketInfo() {
    if (this.selectedCsv) {
      this.loading = true
      const URL = `dashboard/uploadMarketInfo`
      let formData = new FormData()
      formData.append('csv', this.selectedCsv, this.selectedCsv.name)
      this.RequestService.dash_putWithImage(URL, formData).subscribe(
        (response) => {
          this.loading = false
          this.message = response.message
          this.openSuccessModal = true
          window.location.reload()
        },
        (error) => this.catchError(error)
      )
    } else {
      this.errors = 'You Must Attch A csv File'
    }
  }
  catchError(errorResponse) {
    this.loading = false
    const { error } = errorResponse
    return (this.errors = error.error)
  }
  clearInputId() {
    this.InputId = null
  }
  prepareToDeleteInput(data: object) {
    this.inputDelete = data
    this.openAddModal = false
    this.openEditModal = false
    this.openSuccessModal = false
    this.openDeleteModal = true
  }
  deleteInput(id) {
    this.InputId = null
    this.loading = true
    this.RequestService.dash_delete(id, 'dashboard/dropRecord').subscribe(
      (response) => {
        this.loading = false
        this.success = true
        this.message = response.message
        // load modal
        this.openEditModal = false
        this.openDeleteModal = false
        this.openAddModal = false
        this.openSuccessModal = true
        this.reloadInput()
        window.location.reload()
      },
      (errorResponse) => {
        this.loading = false
        const { error } = errorResponse
        return (this.errors = error.error)
      }
    )
  }
  getMessage(message: string) {
    this.message = message
    // load modal
    this.openEditModal = false
    this.openDeleteModal = false
    this.openAddModal = false
    this.openSuccessModal = true
  }
  Clear(diagnosisT) {
    this.selectedCrops = null

    diagnosisT.filter(null, 'crop', 'in')
  }
}
